export default __webpack_public_path__ + "static/media/work1.a82a46c4.png";